/**
 * trackEvent — safely emit a custom Plausible event.
 * Guarded so it silently no-ops if Plausible is blocked (ad-blockers).
 */
export const trackEvent = (name) => {
  if (typeof window !== "undefined" && typeof window.plausible === "function") {
    window.plausible(name);
  }
};
